export interface GetSuggestionsRequest {
  commercialChannelCode: string;
  suggestionType: string;
  prefix?: string;
  prefixType?: string;
  page?: number;
  fetch?: number;
  customerId?: number;
  searchType?: string;
}
